import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Text,
  Link as ChakraLink,
} from '@chakra-ui/react';

import { FiLogOut } from 'react-icons/fi';

import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
  FiMenu,
  FiBell,
  FiChevronDown,
} from 'react-icons/fi';

import { useToast } from '@chakra-ui/react';

// Components
import Sidebar from '../Nav/Sidebar';
import Backdrop from '../Elements/Backdrop';
// Assets
import LogoIcon from '../../assets/svg/Logo';
import BurgerIcon from '../../assets/svg/BurgerIcon';
import Login from '../Login';

import axios from 'axios';
import Cookies from 'js-cookie';
import ProfileModel from '../Elements/ProfileModel';

export default function TopNavbar() {
  const bgColor = useColorModeValue('white', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check for the "emailVerified" flag in local storage
    const emailVerified = localStorage.getItem("emailVerified");

    // If email verification was successful, show the homepage link instead of the login modal
    if (emailVerified === "true") {
      setShowLoginModal(false);
      localStorage.removeItem("emailVerified"); // Remove the flag
    }
  }, []);

  const toast = useToast();
  const payload = Cookies.get('payload');
  const handleSelected = async () => {
    // const res = await axios
    //   .post('https://globalizer-api.onrender.com/api/user/logout', {
    //     token: localStorage.getItem('token'),
    //   })
    //   .then((res) => {
    //     return res;
    //   })
    //   .catch((err) => console.log(err));
    Cookies.remove('payload')
    navigate('/')
    toast({
      title: 'Logged out Successfully',
      description: 'You have successfully logged out.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', () => setY(window.scrollY));
    return () => {
      window.removeEventListener('scroll', () => setY(window.scrollY));
    };
  }, [y]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="flexCenter animate whiteBg"
        style={y > 100 ? { height: '60px' } : { height: '80px' }}
      >
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="home" smooth={true}>
            <LogoIcon />
            <h1 style={{ marginLeft: '15px' }} className="font20 extraBold">
              ReviewMySop
            </h1>
          </Link>
          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: '10px 15px' }}
                to="home"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Home
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: '10px 15px' }}
                to="services"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Services
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: '10px 15px' }}
                to="aboutus"
                spy={true}
                smooth={true}
                offset={-80}
              >
                About Us
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: '10px 15px' }}
                to="testimonials"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Testimonials
              </Link>
            </li>

            <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: '10px 15px' }}
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Contact
              </Link>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            {payload ? (
              <>
                <ProfileModel></ProfileModel>
              </>
            ) : (
              <li className="semiBold font15 pointer">
                <a
                  onClick={() => setShowLoginModal(true)}
                  style={{ padding: '10px 30px 10px 0' }}
                >
                  Log in
                </a>
              </li>
            )}
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
      {showLoginModal && (
        <Modal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)}>
          <ModalOverlay />
          <ModalContent>
            {/* <ModalHeader>
              <Heading fontSize="4xl">Sign in to your account</Heading>
              <Text fontSize="lg" color="gray.600">
                to enjoy all of our cool{" "}
                <ChakraLink color="blue.400">features</ChakraLink> ✌️
              </Text>
            </ModalHeader> */}
            <ModalCloseButton />
            <ModalBody>
              <Login onClose={() => setShowLoginModal(false)} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;
